import print from 'vue3-print-nb'
import permission from './permission'
import copy from './copy'

export default app => {
  app.use(print)
  app.directive('permission', permission)
  app.directive('copy', copy)
}
